import http from '../api/http'

export default class quoteApi {
  static createQuote(endpoint, riskData) {
    return http.post(endpoint, riskData)
  }

  static updateQuote(endpoint, quoteData, partialValidation, scheme) {
    const contentType = `application/tempcover.updatequote${scheme}representation+json`

    return http.put(endpoint, quoteData, {
      headers: {
        Accept: 'application/tempcover.UpdateQuoteResultRepresentation+json',
        'Content-Type': contentType,
      },
    })
  }

  static updateUnderwriter(endpoint, data) {
    return http.put(endpoint, data, {
      headers: {
        Accept:
          'application/tempcover.UpdateQuotingUnderwriterAndPremiumUnitsRepresentation+json',
      },
    })
  }

  static getPrice(endpoint, quoteData, headers) {
    return http.post(endpoint, quoteData, {
      headers: headers,
    })
  }

  static getQuoteSummary(endpoint) {
    return http.get(endpoint)
  }

  static getMotorQuote(endpoint) {
    return http.get(endpoint, {
      headers: {
        Accept:
          'application/tempcover.PrivateCarMotorQuoteDetailsRepresentation+json',
      },
    })
  }

  static unlockQuote(endpoint, data) {
    return http.put(endpoint, data, {
      headers: {
        Accept: 'application/tempcover.DecryptedQuoteRepresentation+json',
      },
    })
  }
}
